import Request from '../../net/js/request';
import { IS_NAME_UNIQUE_PATH } from '../../constants';

async function isNameUnique(name_, client) {
  return new Promise(async(resolve, reject) => {
    if (!this.isNameValid(name_)) {
      resolve(false);
    }

    const xhr = new Request();
    const config = {
      path: IS_NAME_UNIQUE_PATH,
      parameters: { name: name_ },
      hmacId: client.hmacId,
      hmacSecret: client.hmacSecret,
    };

    let res = {};
    try {
      res = await xhr.makeRequest(config);
    } catch (e) {
      reject(e);
    }

    if (res.unique && res.valid) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
}

function isNameValid(name) {
  const regex = /^(?=[0-9a-zA-Z]{8,30}$)([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+).*$/;
  return regex.test(name);
}

export default {
  isNameUnique,
  isNameValid,
};
